import { render } from "./PdfModal.vue?vue&type=template&id=5c15be4a&scoped=true"
import script from "./PdfModal.vue?vue&type=script&lang=js"
export * from "./PdfModal.vue?vue&type=script&lang=js"

import "./PdfModal.vue?vue&type=style&index=0&id=5c15be4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c15be4a"]])

export default __exports__